import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDropDownValuesQueryVariables = Types.Exact<{
  dropDownQuery: Types.DropDownQuery;
}>;


export type GetDropDownValuesQuery = { __typename?: 'Query', infoPortalSelect?: Array<{ __typename?: 'DropDown', id?: string | null, text?: string | null }> | null };

export type InfoPortalQueryApiQueryVariables = Types.Exact<{
  sr5Request: Types.Sr5Request;
}>;


export type InfoPortalQueryApiQuery = { __typename?: 'Query', findSR5ReportResults?: Array<{ __typename?: 'SR5Response', id?: number | null, compcode?: string | null, currency?: string | null, keydate?: string | null, maxrows?: number | null, partnerno?: string | null, totbalance?: number | null, logsys?: string | null, positions?: Array<{ __typename?: 'SR5LineItem', amtdoccur?: number | null, blinedate?: string | null, cleardate?: string | null, busarea?: string | null, clrdocno?: string | null, currency?: string | null, docdate?: string | null, docno?: string | null, doctype?: string | null, duedate?: string | null, dunnlevel?: string | null, headId?: number | null, partnerno?: string | null, pmntblock?: string | null, pmnttrms?: string | null, pstngdate?: string | null, refdocno?: string | null }> | null }> | null };

export type InfoPortalBalancesNr5ApiQueryVariables = Types.Exact<{
  nr5Request: Types.Sr5Request;
}>;


export type InfoPortalBalancesNr5ApiQuery = { __typename?: 'Query', findNR5ReportResults?: Array<{ __typename?: 'SR5Response', id?: number | null, logsys?: string | null, compcode?: string | null, currency?: string | null, keydate?: string | null, maxrows?: number | null, partnerno?: string | null, totbalance?: number | null, positions?: Array<{ __typename?: 'SR5LineItem', amtdoccur?: number | null, blinedate?: string | null, busarea?: string | null, clrdocno?: string | null, currency?: string | null, docdate?: string | null, docno?: string | null, doctype?: string | null, duedate?: string | null, dunnlevel?: string | null, headId?: number | null, partnerno?: string | null, cleardate?: string | null, pmntblock?: string | null, pmnttrms?: string | null, pstngdate?: string | null, refdocno?: string | null }> | null }> | null };

export type InfoPortalPaymentReportApiQueryVariables = Types.Exact<{
  sr4Request: Types.Sr4Request;
  reportType: Types.Scalars['String']['input'];
}>;


export type InfoPortalPaymentReportApiQuery = { __typename?: 'Query', findPaymentReportResults?: Array<{ __typename?: 'SR4Response', id?: number | null, logsys?: string | null, compcode?: string | null, partnerno?: string | null, contactap?: string | null, paymadviceno?: string | null, paymdate?: string | null, totpaymamnt?: number | null, currency?: string | null, extinvoice?: string | null, bmwdocno?: string | null, documentdate?: string | null, bankaccount?: string | null, bankcode?: string | null, swift?: string | null, iban?: string | null, maxrows?: number | null, deliverynoteno?: string | null, positions?: Array<{ __typename?: 'SR4LineItem', headId?: number | null, bmwdocno?: string | null, extinvoice?: string | null, currency?: string | null, documentdate?: string | null, spaborderno?: string | null, invoiceamount?: number | null, settlementtype?: string | null, deliverynoteno?: string | null }> | null }> | null };

export type RetrieveInvoiceReportQueryVariables = Types.Exact<{
  invoiceFilter: Types.InvoiceFilter;
  reportName: Types.Scalars['String']['input'];
}>;


export type RetrieveInvoiceReportQuery = { __typename?: 'Query', retrieveInvoicesReport?: Array<{ __typename?: 'InvoiceHeadDTO', id?: number | null, logsys?: string | null, compcode?: string | null, invstat?: string | null, invoicestatus?: string | null, busarea?: string | null, partnerno?: string | null, partnerinvno?: string | null, bmwdocno?: string | null, paymentnumber?: string | null, docdate?: string | null, gross?: number | null, doccurrency?: string | null, dunnlevel?: string | null, companyname?: string | null, settletype?: string | null, invstatcode?: string | null, invprocess?: string | null, invdirection?: string | null, invreceiptdate?: string | null, paymentdate?: string | null, cumulativeno?: string | null, paymentterm?: string | null, purchasename?: string | null, purchasephone?: string | null, taxrate?: number | null, taxamount?: number | null, totpaymamnt?: number | null, purchasemail?: string | null, recipientname?: string | null, recipientphone?: string | null, recipientmail?: string | null, contactap?: string | null, contactcomplaint?: string | null, contactinvoice?: string | null, doctype?: string | null, duedate?: string | null, net?: number | null, basedate?: string | null, dunnarchvie?: string | null, grossamount?: number | null, currency?: string | null, extinvoice?: string | null, documentdate?: string | null, paymadviceno?: string | null, paymdate?: string | null, deliverynoteNo?: string | null, purchaseOrderNo?: string | null, maxrows?: number | null, rejectiondate?: string | null, fiscalyear?: string | null, rejectionletteruri?: string | null, rejectionLetterFileName?: string | null, companycode?: string | null, purchaseorderno?: string | null, deliverynoteno?: string | null, xSuiteRejectionUrl?: string | null, positions?: Array<{ __typename?: 'InvoicePositionDTO', headId?: number | null, plantname?: string | null, spaborderno?: string | null, confirmationno?: string | null, purchasename?: string | null, purchasephone?: string | null, plantcode?: string | null, purchasemail?: string | null, purchaseorderno?: string | null, deliverynoteno?: string | null, deliverynotedate?: string | null, recipientname?: string | null, recipientphone?: string | null, receiptdate?: string | null, recipientmail?: string | null, duedate?: string | null, materialdocno?: string | null, taxrate?: number | null, currency?: string | null, netamount?: number | null, purchaseorderitem?: string | null }> | null }> | null };

export type InfoPortalSr2QueryApiQueryVariables = Types.Exact<{
  sr2Request: Types.Sr2Request;
  reportName: Types.Scalars['String']['input'];
}>;


export type InfoPortalSr2QueryApiQuery = { __typename?: 'Query', findSR2ReportResults?: Array<{ __typename?: 'SR2Response', id?: string | null, logsys?: string | null, companyCode?: string | null, companyName?: string | null, partnerNumber?: string | null, partnerName?: string | null, purchaseOrderNumber?: string | null, purchaseorderdate?: string | null, materialDocNumber?: string | null, grScDate?: string | null, gjahr?: string | null, bmwDocNumber?: string | null, xblnrAlt?: string | null, invoiceDate?: string | null, invoicePostDate?: string | null, partnerInvoiceNumber?: string | null, settlementType?: string | null, deliveryNoteNumber?: string | null, deliveryNoteDate?: string | null, confirmationNumber?: string | null, grValue?: number | null, currency?: string | null, plantCode?: string | null, plantName?: string | null, businessAreaCode?: string | null, businessAreaName?: string | null, documentType?: string | null, invoiceVerificationContactEmail?: string | null, recipientName?: string | null, recipientEmail?: string | null, recipientTel?: string | null, spabNumber?: string | null, docdate?: string | null, quantity?: string | null, units?: string | null, materialNumber?: string | null, materialDescription?: string | null, grstatus?: string | null, ivContactEmail?: string | null, maxrows?: string | null, procurement?: string | null, purchaseOrderItem?: string | null, overduestatus?: string | null, deliverypostdate?: string | null, materialText?: string | null, grnumber?: string | null, netamount?: string | null, extinvoice?: string | null, bmwdocno?: string | null, documentdate?: string | null, positions?: Array<{ __typename?: 'SR2GoodsReceiptLineItem', headId?: string | null, grscitem?: string | null, material?: string | null, materialtext?: string | null, grunit?: string | null, grqty?: string | null }> | null }> | null };

export type InfoPortalSr1QueryApiQueryVariables = Types.Exact<{
  sr1Request: Types.Sr1Request;
  reportName: Types.Scalars['String']['input'];
}>;


export type InfoPortalSr1QueryApiQuery = { __typename?: 'Query', findSR1ReportResults?: Array<{ __typename?: 'SR1Response', id?: string | null, logsys?: string | null, compname?: string | null, partnerlf?: string | null, partnerlfname?: string | null, settletype?: string | null, settletypetxt?: string | null, potype?: string | null, ponumber?: string | null, podate?: string | null, povalue?: number | null, currency?: string | null, podlvstattxt?: string | null, invstattxt?: string | null, pmnttrms?: string | null, termsdelivery?: string | null, contactponame?: string | null, contactpoemail?: string | null, itemname?: string | null, quantity?: string | null, pounit?: string | null, plant?: string | null, busarea?: string | null, busareaname?: string | null, invoicee?: string | null, maxrows?: string | null, positions?: Array<{ __typename?: 'PurchaseOderLineItem', headId?: string | null, poNumber?: string | null, poItem?: string | null, material?: string | null, materialText?: string | null, quantity?: string | null, pounit?: string | null, nettitemvalue?: string | null, deliveryNoteDate?: string | null, plantName?: string | null, busArea?: string | null, changedate?: string | null, contactGrName?: string | null, contactGrEmail?: string | null, deliveryaddress?: string | null, invoicedValue?: string | null, invoiceQuantity?: string | null, openValue?: string | null, openQuantity?: string | null }> | null }> | null };

export type RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables = Types.Exact<{
  blobId: Types.Scalars['Float']['input'];
  application: Types.Scalars['String']['input'];
}>;


export type RetrieveDocumentByBlobIdAndApplicationTypeQuery = { __typename?: 'Query', retrieveDocumentByBlobIdAndApplicationType: { __typename?: 'SurveyDocumentResponse', success?: string | null, value?: { __typename?: 'SurveyDocumentValue', encodedFileData?: string | null, fileName?: string | null, mimeType?: string | null } | null } };

export type CzQueryApiQueryVariables = Types.Exact<{
  czRequest: Types.CzGenericFilter;
  report: Types.Scalars['String']['input'];
}>;


export type CzQueryApiQuery = { __typename?: 'Query', findCZReport?: Array<{ __typename?: 'CZResponse', id?: number | null, logsys?: string | null, czcompcode?: string | null, partnerno?: string | null, invoicestatus?: string | null, bmwdocno?: string | null, documentdate?: string | null, documentType?: string | null, revstattxt?: string | null, invpostdate?: string | null, grossamount?: number | null, currency?: string | null, fapiaono?: string | null, fiscalyear?: string | null, revdocno?: string | null, originvoiceno?: string | null, originvoiceyear?: string | null, origfapiaono?: string | null, maxrows?: number | null, positions?: Array<{ __typename?: 'CZLineItem', ponumber?: string | null, poitem?: string | null, material?: string | null, materialtext?: string | null, materialtextzh?: string | null, pounit?: string | null, pounitprice?: number | null, quantity?: number | null, deliverynoteno?: string | null, grdate?: string | null, amount?: number | null, currency?: string | null, bmwdocno?: string | null, reitem?: string | null, supplierclaim?: string | null, plantname?: string | null }> | null }> | null };

export type DownloadedRejectionLetterReportQueryVariables = Types.Exact<{
  invoiceFilter: Types.InvoiceFilter;
}>;


export type DownloadedRejectionLetterReportQuery = { __typename?: 'Query', getDownloadedRejectionLetters: Array<{ __typename?: 'DownloadedRejectionLetter', fileName?: string | null, companyCodeName?: string | null, downloadDate?: string | null, insertDate?: string | null, partnerNo?: string | null, documentNumber?: string | null, partnerInvoice?: string | null, username?: string | null, firstname?: string | null, lastname?: string | null }> };

export type GetInfoPortalAggregateUsageStatsQueryVariables = Types.Exact<{
  stats: Types.KpiAggregatesQuery;
}>;


export type GetInfoPortalAggregateUsageStatsQuery = { __typename?: 'Query', getKPIUsageForInfoPortal: Array<{ __typename?: 'KPIAggregatesResponse', dayOfYear?: string | null, reportName?: string | null, partnerName?: string | null, count?: number | null }> };

export type InfoPortalFreightReportQueryVariables = Types.Exact<{
  freightRequest: Types.Ly7Request;
}>;


export type InfoPortalFreightReportQuery = { __typename?: 'Query', findLY7Report?: Array<{ __typename?: 'LY7Response', compcode?: string | null, logsys?: string | null, partnerno?: string | null, ponumber?: string | null, itemstatus?: string | null, fsdnumber?: string | null, grnumber?: string | null, deliverypostdate?: string | null, netamount?: number | null, currency?: string | null, extinvoice?: string | null, bmwdocno?: string | null, maxrows?: number | null, documentdate?: string | null }> | null };

export type InfoPortalFixedCostReportQueryVariables = Types.Exact<{
  fixedCost: Types.Ly6Request;
}>;


export type InfoPortalFixedCostReportQuery = { __typename?: 'Query', findLY6Report?: Array<{ __typename?: 'LY6Response', compcode?: string | null, logsys?: string | null, partnerno?: string | null, ponumber?: string | null, fixedcostno?: string | null, invbaselinedate?: string | null, currency?: string | null, itemstatus?: string | null, extinvoice?: string | null, bmwdocno?: string | null, invpostdate?: string | null, overduestatus?: string | null, netamount?: number | null, maxrows?: number | null }> | null };

export type InfoPortalSupplierClaimsReportQueryVariables = Types.Exact<{
  supplierClaims: Types.Ly6Request;
}>;


export type InfoPortalSupplierClaimsReportQuery = { __typename?: 'Query', findLY5Report?: Array<{ __typename?: 'LY5Response', compcode?: string | null, logsys?: string | null, partnerno?: string | null, ponumber?: string | null, claimstatus?: string | null, poposition?: string | null, materialno?: string | null, description?: string | null, supplclaimno?: string | null, givolume?: number | null, matshareamnt?: number | null, handsurchamnt?: number | null, totalamnt?: number | null, currency?: string | null, extinvoice?: string | null, bmwdocno?: string | null, invpostdate?: string | null, invReference?: string | null, invbaselinedate?: string | null, overduestatus?: string | null, maxrows?: number | null }> | null };

export type RetrieveRevaluationReportQueryVariables = Types.Exact<{
  revaluationFilter: Types.RevaluationFilter;
}>;


export type RetrieveRevaluationReportQuery = { __typename?: 'Query', findLY4Report?: Array<{ __typename?: 'RevaluationHeadDTO', compcode?: string | null, logsys?: string | null, partnerno?: string | null, status?: string | null, purchaseordernumber?: string | null, poposition?: string | null, materialnumber?: string | null, description?: string | null, revalnumber?: string | null, revaltype?: string | null, oldnetamount?: number | null, newnetamount?: number | null, difference?: number | null, total?: number | null, currency?: string | null, documentdate?: string | null, bmwdocnumber?: string | null, grnumber?: string | null, overduestatus?: string | null, changedon?: string | null, maxrows?: number | null, extinvoice?: string | null, positions?: Array<{ __typename?: 'RevaluationPositionDTO', revalnumber?: string | null, deliverynote?: string | null, grnumber?: string | null, material?: string | null, materialtext?: string | null, oldnet?: number | null, newnet?: number | null, diffnet?: number | null, currency?: string | null }> | null }> | null };

export type XSuiteDownloadQueryVariables = Types.Exact<{
  fetchBlobRequest: Types.FetchBlobRequest;
}>;


export type XSuiteDownloadQuery = { __typename?: 'Query', retrieveRejectionLetterByURL: { __typename?: 'SurveyDocumentValue', encodedFileData?: string | null, fileName?: string | null, mimeType?: string | null } };

export type CorapiQueryVariables = Types.Exact<{
  cr1Query: Types.Cr1Filter;
}>;


export type CorapiQuery = { __typename?: 'Query', findCR1ReportResults?: Array<{ __typename?: 'CR1Response', id?: number | null, logsys?: string | null, companyCode?: string | null, companyName?: string | null, partnerNumber?: string | null, partnerName?: string | null, lfStreet?: string | null, lfCountry?: string | null, lfPostalCode?: string | null, lfCity?: string | null, vatNr?: string | null, poNumber?: string | null, materialNumber?: string | null, materialDescription?: string | null, deliveryNoteNumber?: string | null, deliveryNoteDate?: string | null, materialDocNumber?: string | null, gjahr?: string | null, grScItem?: string | null, grScDate?: string | null, grQuantity?: string | null, grUnit?: string | null, partnerLl?: string | null, partnerLlName?: string | null, llStreet?: string | null, llCountry?: string | null, llPostalCode?: string | null, llCity?: string | null, plantCode?: string | null, plantName?: string | null, plantAddress?: string | null, boardMemberName?: string | null, maxrows?: number | null, blobId?: number | null, documentCreated?: boolean | null, documentCreationDate?: string | null, yearMonth?: string | null, positions?: Array<{ __typename?: 'CR1Position', logsys?: string | null, pos?: number | null, poNumber?: string | null, material?: string | null, materialText?: string | null, deliveryNote?: string | null, deliveryNoteDate?: string | null, materialDoc?: string | null, gjahr?: string | null, grScItem?: string | null, grScDate?: string | null, grQty?: number | null, grUnit?: string | null, plant?: string | null, plantName?: string | null, plantAddress?: string | null, boardMemberName?: string | null, companyName?: string | null }> | null }> | null };

export type FetchSapConfigurationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchSapConfigurationQuery = { __typename?: 'Query', getSapSystemConfig: Array<{ __typename?: 'SapSystemUpdate', reportName: string, description: string, systemStatusList: Array<{ __typename?: 'SystemStatus', id?: number | null, userName: string, secretPlaceholder: string, vaultProperty: string, secret?: string | null, url: string, path: string, systemName: string, systemNameFreeText: string, filerResultsRule?: string | null, description?: string | null, active: boolean, reachable: boolean, placeHolderConfigured: boolean, vaultPropertyFound: boolean }> }> };

export type FetchAppVariablesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchAppVariablesQuery = { __typename?: 'Query', getAllAppVariables: Array<{ __typename?: 'AppVariable', key?: string | null, value?: string | null }> };

export type UpsertAppVariableMutationVariables = Types.Exact<{
  input: Types.AppVariableInput;
}>;


export type UpsertAppVariableMutation = { __typename?: 'Mutation', addAppVariable: boolean };

export type UpdateSapConfigurationQueryVariables = Types.Exact<{
  sapConfig: Types.SapSystemUpdateInput;
}>;


export type UpdateSapConfigurationQuery = { __typename?: 'Query', updateSapSystemConfig: { __typename?: 'SapSystemUpdate', reportName: string, description: string, systemStatusList: Array<{ __typename?: 'SystemStatus', url: string, path: string, active: boolean, filerResultsRule?: string | null }> } };

export type DeleteSapSystemConfigQueryVariables = Types.Exact<{
  id: Types.Scalars['Float']['input'];
}>;


export type DeleteSapSystemConfigQuery = { __typename?: 'Query', deleteSapSystemConfig?: { __typename?: 'SapSystemUpdate', reportName: string, description: string, systemStatusList: Array<{ __typename?: 'SystemStatus', id?: number | null, url: string, path: string, active: boolean, filerResultsRule?: string | null }> } | null };

export type CreateConfirmationOfArrivalPdfQueryVariables = Types.Exact<{
  input: Types.Cr1PdfRequest;
  language: Types.Scalars['String']['input'];
}>;


export type CreateConfirmationOfArrivalPdfQuery = { __typename?: 'Query', createConfirmationOfArrivalPDF: { __typename?: 'GeneratedPDF', blobId: number, creationTime?: string | null } };

export type InfoPortalTnr1QueryApiQueryVariables = Types.Exact<{
  tnr1Request: Types.CommissionFilterInput;
}>;


export type InfoPortalTnr1QueryApiQuery = { __typename?: 'Query', findTNR1ReportResults?: Array<{ __typename?: 'CommissionHeader', logsys?: string | null, compCode?: string | null, compName?: string | null, documentNR?: string | null, documentDate?: string | null, dealerNR?: string | null, dealerName?: string | null, salesPartner?: string | null, vinNumber?: string | null, handOverDate?: string | null, brand?: string | null, modelCode?: string | null, commissionType?: string | null, recipient?: string | null, salesCategory?: string | null, valueType?: string | null, currency?: string | null, paymentType?: string | null, baseValue?: string | null, percentage?: string | null, netValuePaid?: string | null, grossValuePaid?: string | null, itemNr?: string | null, alphabet?: string | null }> | null };


export const GetDropDownValuesDocument = gql`
    query GetDropDownValues($dropDownQuery: DropDownQuery!) {
  infoPortalSelect(query: $dropDownQuery) {
    id
    text
  }
}
    `;

/**
 * __useGetDropDownValuesQuery__
 *
 * To run a query within a React component, call `useGetDropDownValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDropDownValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDropDownValuesQuery({
 *   variables: {
 *      dropDownQuery: // value for 'dropDownQuery'
 *   },
 * });
 */
export function useGetDropDownValuesQuery(baseOptions: Apollo.QueryHookOptions<GetDropDownValuesQuery, GetDropDownValuesQueryVariables> & ({ variables: GetDropDownValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>(GetDropDownValuesDocument, options);
      }
export function useGetDropDownValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>(GetDropDownValuesDocument, options);
        }
// @ts-ignore
export function useGetDropDownValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>;
export function useGetDropDownValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDropDownValuesQuery | undefined, GetDropDownValuesQueryVariables>;
export function useGetDropDownValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>(GetDropDownValuesDocument, options);
        }
export type GetDropDownValuesQueryHookResult = ReturnType<typeof useGetDropDownValuesQuery>;
export type GetDropDownValuesLazyQueryHookResult = ReturnType<typeof useGetDropDownValuesLazyQuery>;
export type GetDropDownValuesSuspenseQueryHookResult = ReturnType<typeof useGetDropDownValuesSuspenseQuery>;
export type GetDropDownValuesQueryResult = Apollo.QueryResult<GetDropDownValuesQuery, GetDropDownValuesQueryVariables>;
export const InfoPortalQueryApiDocument = gql`
    query InfoPortalQueryApi($sr5Request: SR5Request!) {
  findSR5ReportResults(sr5Query: $sr5Request) {
    id
    compcode
    currency
    keydate
    maxrows
    partnerno
    totbalance
    logsys
    positions {
      amtdoccur
      blinedate
      cleardate
      busarea
      clrdocno
      currency
      docdate
      docno
      doctype
      duedate
      dunnlevel
      headId
      partnerno
      pmntblock
      pmnttrms
      pstngdate
      refdocno
    }
  }
}
    `;

/**
 * __useInfoPortalQueryApiQuery__
 *
 * To run a query within a React component, call `useInfoPortalQueryApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalQueryApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalQueryApiQuery({
 *   variables: {
 *      sr5Request: // value for 'sr5Request'
 *   },
 * });
 */
export function useInfoPortalQueryApiQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables> & ({ variables: InfoPortalQueryApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>(InfoPortalQueryApiDocument, options);
      }
export function useInfoPortalQueryApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>(InfoPortalQueryApiDocument, options);
        }
// @ts-ignore
export function useInfoPortalQueryApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>;
export function useInfoPortalQueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalQueryApiQuery | undefined, InfoPortalQueryApiQueryVariables>;
export function useInfoPortalQueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>(InfoPortalQueryApiDocument, options);
        }
export type InfoPortalQueryApiQueryHookResult = ReturnType<typeof useInfoPortalQueryApiQuery>;
export type InfoPortalQueryApiLazyQueryHookResult = ReturnType<typeof useInfoPortalQueryApiLazyQuery>;
export type InfoPortalQueryApiSuspenseQueryHookResult = ReturnType<typeof useInfoPortalQueryApiSuspenseQuery>;
export type InfoPortalQueryApiQueryResult = Apollo.QueryResult<InfoPortalQueryApiQuery, InfoPortalQueryApiQueryVariables>;
export const InfoPortalBalancesNr5ApiDocument = gql`
    query InfoPortalBalancesNR5Api($nr5Request: SR5Request!) {
  findNR5ReportResults(nr5Query: $nr5Request) {
    id
    logsys
    compcode
    currency
    keydate
    maxrows
    partnerno
    totbalance
    positions {
      amtdoccur
      blinedate
      busarea
      clrdocno
      currency
      docdate
      docno
      doctype
      duedate
      dunnlevel
      headId
      partnerno
      cleardate
      pmntblock
      pmnttrms
      pstngdate
      refdocno
    }
  }
}
    `;

/**
 * __useInfoPortalBalancesNr5ApiQuery__
 *
 * To run a query within a React component, call `useInfoPortalBalancesNr5ApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalBalancesNr5ApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalBalancesNr5ApiQuery({
 *   variables: {
 *      nr5Request: // value for 'nr5Request'
 *   },
 * });
 */
export function useInfoPortalBalancesNr5ApiQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables> & ({ variables: InfoPortalBalancesNr5ApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>(InfoPortalBalancesNr5ApiDocument, options);
      }
export function useInfoPortalBalancesNr5ApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>(InfoPortalBalancesNr5ApiDocument, options);
        }
// @ts-ignore
export function useInfoPortalBalancesNr5ApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>;
export function useInfoPortalBalancesNr5ApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalBalancesNr5ApiQuery | undefined, InfoPortalBalancesNr5ApiQueryVariables>;
export function useInfoPortalBalancesNr5ApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>(InfoPortalBalancesNr5ApiDocument, options);
        }
export type InfoPortalBalancesNr5ApiQueryHookResult = ReturnType<typeof useInfoPortalBalancesNr5ApiQuery>;
export type InfoPortalBalancesNr5ApiLazyQueryHookResult = ReturnType<typeof useInfoPortalBalancesNr5ApiLazyQuery>;
export type InfoPortalBalancesNr5ApiSuspenseQueryHookResult = ReturnType<typeof useInfoPortalBalancesNr5ApiSuspenseQuery>;
export type InfoPortalBalancesNr5ApiQueryResult = Apollo.QueryResult<InfoPortalBalancesNr5ApiQuery, InfoPortalBalancesNr5ApiQueryVariables>;
export const InfoPortalPaymentReportApiDocument = gql`
    query InfoPortalPaymentReportApi($sr4Request: SR4Request!, $reportType: String!) {
  findPaymentReportResults(sr4Query: $sr4Request, reportType: $reportType) {
    id
    logsys
    compcode
    partnerno
    contactap
    paymadviceno
    paymdate
    totpaymamnt
    currency
    extinvoice
    bmwdocno
    documentdate
    bankaccount
    bankcode
    swift
    iban
    maxrows
    deliverynoteno
    positions {
      headId
      bmwdocno
      extinvoice
      currency
      documentdate
      spaborderno
      invoiceamount
      settlementtype
      headId
      deliverynoteno
    }
  }
}
    `;

/**
 * __useInfoPortalPaymentReportApiQuery__
 *
 * To run a query within a React component, call `useInfoPortalPaymentReportApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalPaymentReportApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalPaymentReportApiQuery({
 *   variables: {
 *      sr4Request: // value for 'sr4Request'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function useInfoPortalPaymentReportApiQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables> & ({ variables: InfoPortalPaymentReportApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>(InfoPortalPaymentReportApiDocument, options);
      }
export function useInfoPortalPaymentReportApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>(InfoPortalPaymentReportApiDocument, options);
        }
// @ts-ignore
export function useInfoPortalPaymentReportApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>;
export function useInfoPortalPaymentReportApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalPaymentReportApiQuery | undefined, InfoPortalPaymentReportApiQueryVariables>;
export function useInfoPortalPaymentReportApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>(InfoPortalPaymentReportApiDocument, options);
        }
export type InfoPortalPaymentReportApiQueryHookResult = ReturnType<typeof useInfoPortalPaymentReportApiQuery>;
export type InfoPortalPaymentReportApiLazyQueryHookResult = ReturnType<typeof useInfoPortalPaymentReportApiLazyQuery>;
export type InfoPortalPaymentReportApiSuspenseQueryHookResult = ReturnType<typeof useInfoPortalPaymentReportApiSuspenseQuery>;
export type InfoPortalPaymentReportApiQueryResult = Apollo.QueryResult<InfoPortalPaymentReportApiQuery, InfoPortalPaymentReportApiQueryVariables>;
export const RetrieveInvoiceReportDocument = gql`
    query RetrieveInvoiceReport($invoiceFilter: InvoiceFilter!, $reportName: String!) {
  retrieveInvoicesReport(invoiceFilter: $invoiceFilter, reportName: $reportName) {
    id
    logsys
    compcode
    invstat
    invoicestatus
    busarea
    partnerno
    partnerinvno
    bmwdocno
    paymentnumber
    docdate
    gross
    doccurrency
    dunnlevel
    companyname
    settletype
    invstatcode
    invprocess
    invdirection
    invreceiptdate
    paymentdate
    cumulativeno
    paymentterm
    purchasename
    purchasephone
    taxrate
    taxamount
    totpaymamnt
    purchasemail
    recipientname
    recipientphone
    recipientmail
    contactap
    contactcomplaint
    contactinvoice
    doctype
    duedate
    net
    basedate
    dunnarchvie
    grossamount
    currency
    extinvoice
    documentdate
    paymadviceno
    paymdate
    positions {
      headId
      plantname
      spaborderno
      confirmationno
      purchasename
      purchasephone
      plantcode
      purchasemail
      purchaseorderno
      deliverynoteno
      deliverynotedate
      recipientname
      recipientphone
      receiptdate
      recipientmail
      duedate
      materialdocno
      taxrate
      currency
      netamount
      purchaseorderitem
    }
    deliverynoteNo
    purchaseOrderNo
    maxrows
    rejectiondate
    fiscalyear
    rejectionletteruri
    rejectionLetterFileName
    companycode
    purchaseorderno
    deliverynoteno
    xSuiteRejectionUrl
  }
}
    `;

/**
 * __useRetrieveInvoiceReportQuery__
 *
 * To run a query within a React component, call `useRetrieveInvoiceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveInvoiceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveInvoiceReportQuery({
 *   variables: {
 *      invoiceFilter: // value for 'invoiceFilter'
 *      reportName: // value for 'reportName'
 *   },
 * });
 */
export function useRetrieveInvoiceReportQuery(baseOptions: Apollo.QueryHookOptions<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables> & ({ variables: RetrieveInvoiceReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>(RetrieveInvoiceReportDocument, options);
      }
export function useRetrieveInvoiceReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>(RetrieveInvoiceReportDocument, options);
        }
// @ts-ignore
export function useRetrieveInvoiceReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>): Apollo.UseSuspenseQueryResult<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>;
export function useRetrieveInvoiceReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>): Apollo.UseSuspenseQueryResult<RetrieveInvoiceReportQuery | undefined, RetrieveInvoiceReportQueryVariables>;
export function useRetrieveInvoiceReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>(RetrieveInvoiceReportDocument, options);
        }
export type RetrieveInvoiceReportQueryHookResult = ReturnType<typeof useRetrieveInvoiceReportQuery>;
export type RetrieveInvoiceReportLazyQueryHookResult = ReturnType<typeof useRetrieveInvoiceReportLazyQuery>;
export type RetrieveInvoiceReportSuspenseQueryHookResult = ReturnType<typeof useRetrieveInvoiceReportSuspenseQuery>;
export type RetrieveInvoiceReportQueryResult = Apollo.QueryResult<RetrieveInvoiceReportQuery, RetrieveInvoiceReportQueryVariables>;
export const InfoPortalSr2QueryApiDocument = gql`
    query InfoPortalSR2QueryApi($sr2Request: SR2Request!, $reportName: String!) {
  findSR2ReportResults(sr2Query: $sr2Request, reportName: $reportName) {
    id
    logsys
    companyCode
    companyName
    partnerNumber
    partnerName
    purchaseOrderNumber
    purchaseorderdate
    materialDocNumber
    grScDate
    gjahr
    bmwDocNumber
    xblnrAlt
    invoiceDate
    invoicePostDate
    partnerInvoiceNumber
    settlementType
    deliveryNoteNumber
    deliveryNoteDate
    confirmationNumber
    grValue
    currency
    plantCode
    plantName
    businessAreaCode
    businessAreaName
    documentType
    invoiceVerificationContactEmail
    recipientName
    recipientEmail
    recipientTel
    spabNumber
    docdate
    quantity
    units
    materialNumber
    materialDescription
    grstatus
    ivContactEmail
    maxrows
    procurement
    purchaseOrderItem
    overduestatus
    deliverypostdate
    materialText
    grnumber
    netamount
    extinvoice
    bmwdocno
    documentdate
    positions {
      headId
      grscitem
      material
      materialtext
      grunit
      grqty
    }
  }
}
    `;

/**
 * __useInfoPortalSr2QueryApiQuery__
 *
 * To run a query within a React component, call `useInfoPortalSr2QueryApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalSr2QueryApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalSr2QueryApiQuery({
 *   variables: {
 *      sr2Request: // value for 'sr2Request'
 *      reportName: // value for 'reportName'
 *   },
 * });
 */
export function useInfoPortalSr2QueryApiQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables> & ({ variables: InfoPortalSr2QueryApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>(InfoPortalSr2QueryApiDocument, options);
      }
export function useInfoPortalSr2QueryApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>(InfoPortalSr2QueryApiDocument, options);
        }
// @ts-ignore
export function useInfoPortalSr2QueryApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>;
export function useInfoPortalSr2QueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalSr2QueryApiQuery | undefined, InfoPortalSr2QueryApiQueryVariables>;
export function useInfoPortalSr2QueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>(InfoPortalSr2QueryApiDocument, options);
        }
export type InfoPortalSr2QueryApiQueryHookResult = ReturnType<typeof useInfoPortalSr2QueryApiQuery>;
export type InfoPortalSr2QueryApiLazyQueryHookResult = ReturnType<typeof useInfoPortalSr2QueryApiLazyQuery>;
export type InfoPortalSr2QueryApiSuspenseQueryHookResult = ReturnType<typeof useInfoPortalSr2QueryApiSuspenseQuery>;
export type InfoPortalSr2QueryApiQueryResult = Apollo.QueryResult<InfoPortalSr2QueryApiQuery, InfoPortalSr2QueryApiQueryVariables>;
export const InfoPortalSr1QueryApiDocument = gql`
    query InfoPortalSR1QueryApi($sr1Request: SR1Request!, $reportName: String!) {
  findSR1ReportResults(sr1Query: $sr1Request, reportName: $reportName) {
    id
    logsys
    compname
    partnerlf
    partnerlfname
    settletype
    settletypetxt
    potype
    ponumber
    podate
    povalue
    currency
    podlvstattxt
    invstattxt
    pmnttrms
    termsdelivery
    contactponame
    contactpoemail
    itemname
    quantity
    pounit
    plant
    busarea
    busareaname
    invoicee
    maxrows
    positions {
      headId
      poNumber
      poItem
      material
      materialText
      quantity
      pounit
      nettitemvalue
      deliveryNoteDate
      plantName
      busArea
      changedate
      contactGrName
      contactGrEmail
      deliveryaddress
      invoicedValue
      invoiceQuantity
      openValue
      openQuantity
    }
  }
}
    `;

/**
 * __useInfoPortalSr1QueryApiQuery__
 *
 * To run a query within a React component, call `useInfoPortalSr1QueryApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalSr1QueryApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalSr1QueryApiQuery({
 *   variables: {
 *      sr1Request: // value for 'sr1Request'
 *      reportName: // value for 'reportName'
 *   },
 * });
 */
export function useInfoPortalSr1QueryApiQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables> & ({ variables: InfoPortalSr1QueryApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>(InfoPortalSr1QueryApiDocument, options);
      }
export function useInfoPortalSr1QueryApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>(InfoPortalSr1QueryApiDocument, options);
        }
// @ts-ignore
export function useInfoPortalSr1QueryApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>;
export function useInfoPortalSr1QueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalSr1QueryApiQuery | undefined, InfoPortalSr1QueryApiQueryVariables>;
export function useInfoPortalSr1QueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>(InfoPortalSr1QueryApiDocument, options);
        }
export type InfoPortalSr1QueryApiQueryHookResult = ReturnType<typeof useInfoPortalSr1QueryApiQuery>;
export type InfoPortalSr1QueryApiLazyQueryHookResult = ReturnType<typeof useInfoPortalSr1QueryApiLazyQuery>;
export type InfoPortalSr1QueryApiSuspenseQueryHookResult = ReturnType<typeof useInfoPortalSr1QueryApiSuspenseQuery>;
export type InfoPortalSr1QueryApiQueryResult = Apollo.QueryResult<InfoPortalSr1QueryApiQuery, InfoPortalSr1QueryApiQueryVariables>;
export const RetrieveDocumentByBlobIdAndApplicationTypeDocument = gql`
    query retrieveDocumentByBlobIdAndApplicationType($blobId: Float!, $application: String!) {
  retrieveDocumentByBlobIdAndApplicationType(
    blobId: $blobId
    application: $application
  ) {
    success
    value {
      encodedFileData
      fileName
      mimeType
    }
  }
}
    `;

/**
 * __useRetrieveDocumentByBlobIdAndApplicationTypeQuery__
 *
 * To run a query within a React component, call `useRetrieveDocumentByBlobIdAndApplicationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDocumentByBlobIdAndApplicationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveDocumentByBlobIdAndApplicationTypeQuery({
 *   variables: {
 *      blobId: // value for 'blobId'
 *      application: // value for 'application'
 *   },
 * });
 */
export function useRetrieveDocumentByBlobIdAndApplicationTypeQuery(baseOptions: Apollo.QueryHookOptions<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables> & ({ variables: RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>(RetrieveDocumentByBlobIdAndApplicationTypeDocument, options);
      }
export function useRetrieveDocumentByBlobIdAndApplicationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>(RetrieveDocumentByBlobIdAndApplicationTypeDocument, options);
        }
// @ts-ignore
export function useRetrieveDocumentByBlobIdAndApplicationTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>): Apollo.UseSuspenseQueryResult<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>;
export function useRetrieveDocumentByBlobIdAndApplicationTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>): Apollo.UseSuspenseQueryResult<RetrieveDocumentByBlobIdAndApplicationTypeQuery | undefined, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>;
export function useRetrieveDocumentByBlobIdAndApplicationTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>(RetrieveDocumentByBlobIdAndApplicationTypeDocument, options);
        }
export type RetrieveDocumentByBlobIdAndApplicationTypeQueryHookResult = ReturnType<typeof useRetrieveDocumentByBlobIdAndApplicationTypeQuery>;
export type RetrieveDocumentByBlobIdAndApplicationTypeLazyQueryHookResult = ReturnType<typeof useRetrieveDocumentByBlobIdAndApplicationTypeLazyQuery>;
export type RetrieveDocumentByBlobIdAndApplicationTypeSuspenseQueryHookResult = ReturnType<typeof useRetrieveDocumentByBlobIdAndApplicationTypeSuspenseQuery>;
export type RetrieveDocumentByBlobIdAndApplicationTypeQueryResult = Apollo.QueryResult<RetrieveDocumentByBlobIdAndApplicationTypeQuery, RetrieveDocumentByBlobIdAndApplicationTypeQueryVariables>;
export const CzQueryApiDocument = gql`
    query CZQueryApi($czRequest: CZGenericFilter!, $report: String!) {
  findCZReport(czgenericFilter: $czRequest, reportName: $report) {
    id
    logsys
    czcompcode
    partnerno
    invoicestatus
    bmwdocno
    documentdate
    documentType
    revstattxt
    invpostdate
    grossamount
    currency
    fapiaono
    fiscalyear
    revdocno
    originvoiceno
    originvoiceyear
    origfapiaono
    positions {
      ponumber
      poitem
      material
      materialtext
      materialtextzh
      pounit
      pounitprice
      quantity
      deliverynoteno
      grdate
      amount
      currency
      bmwdocno
      reitem
      supplierclaim
      plantname
    }
    maxrows
  }
}
    `;

/**
 * __useCzQueryApiQuery__
 *
 * To run a query within a React component, call `useCzQueryApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useCzQueryApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCzQueryApiQuery({
 *   variables: {
 *      czRequest: // value for 'czRequest'
 *      report: // value for 'report'
 *   },
 * });
 */
export function useCzQueryApiQuery(baseOptions: Apollo.QueryHookOptions<CzQueryApiQuery, CzQueryApiQueryVariables> & ({ variables: CzQueryApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CzQueryApiQuery, CzQueryApiQueryVariables>(CzQueryApiDocument, options);
      }
export function useCzQueryApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CzQueryApiQuery, CzQueryApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CzQueryApiQuery, CzQueryApiQueryVariables>(CzQueryApiDocument, options);
        }
// @ts-ignore
export function useCzQueryApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CzQueryApiQuery, CzQueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<CzQueryApiQuery, CzQueryApiQueryVariables>;
export function useCzQueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CzQueryApiQuery, CzQueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<CzQueryApiQuery | undefined, CzQueryApiQueryVariables>;
export function useCzQueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CzQueryApiQuery, CzQueryApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CzQueryApiQuery, CzQueryApiQueryVariables>(CzQueryApiDocument, options);
        }
export type CzQueryApiQueryHookResult = ReturnType<typeof useCzQueryApiQuery>;
export type CzQueryApiLazyQueryHookResult = ReturnType<typeof useCzQueryApiLazyQuery>;
export type CzQueryApiSuspenseQueryHookResult = ReturnType<typeof useCzQueryApiSuspenseQuery>;
export type CzQueryApiQueryResult = Apollo.QueryResult<CzQueryApiQuery, CzQueryApiQueryVariables>;
export const DownloadedRejectionLetterReportDocument = gql`
    query DownloadedRejectionLetterReport($invoiceFilter: InvoiceFilter!) {
  getDownloadedRejectionLetters(invoiceFilter: $invoiceFilter) {
    fileName
    companyCodeName
    downloadDate
    insertDate
    partnerNo
    documentNumber
    partnerInvoice
    username
    firstname
    lastname
  }
}
    `;

/**
 * __useDownloadedRejectionLetterReportQuery__
 *
 * To run a query within a React component, call `useDownloadedRejectionLetterReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadedRejectionLetterReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadedRejectionLetterReportQuery({
 *   variables: {
 *      invoiceFilter: // value for 'invoiceFilter'
 *   },
 * });
 */
export function useDownloadedRejectionLetterReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables> & ({ variables: DownloadedRejectionLetterReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>(DownloadedRejectionLetterReportDocument, options);
      }
export function useDownloadedRejectionLetterReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>(DownloadedRejectionLetterReportDocument, options);
        }
// @ts-ignore
export function useDownloadedRejectionLetterReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>;
export function useDownloadedRejectionLetterReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadedRejectionLetterReportQuery | undefined, DownloadedRejectionLetterReportQueryVariables>;
export function useDownloadedRejectionLetterReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>(DownloadedRejectionLetterReportDocument, options);
        }
export type DownloadedRejectionLetterReportQueryHookResult = ReturnType<typeof useDownloadedRejectionLetterReportQuery>;
export type DownloadedRejectionLetterReportLazyQueryHookResult = ReturnType<typeof useDownloadedRejectionLetterReportLazyQuery>;
export type DownloadedRejectionLetterReportSuspenseQueryHookResult = ReturnType<typeof useDownloadedRejectionLetterReportSuspenseQuery>;
export type DownloadedRejectionLetterReportQueryResult = Apollo.QueryResult<DownloadedRejectionLetterReportQuery, DownloadedRejectionLetterReportQueryVariables>;
export const GetInfoPortalAggregateUsageStatsDocument = gql`
    query GetInfoPortalAggregateUsageStats($stats: KPIAggregatesQuery!) {
  getKPIUsageForInfoPortal(kpiQuery: $stats) {
    dayOfYear
    reportName
    partnerName
    count
  }
}
    `;

/**
 * __useGetInfoPortalAggregateUsageStatsQuery__
 *
 * To run a query within a React component, call `useGetInfoPortalAggregateUsageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoPortalAggregateUsageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoPortalAggregateUsageStatsQuery({
 *   variables: {
 *      stats: // value for 'stats'
 *   },
 * });
 */
export function useGetInfoPortalAggregateUsageStatsQuery(baseOptions: Apollo.QueryHookOptions<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables> & ({ variables: GetInfoPortalAggregateUsageStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>(GetInfoPortalAggregateUsageStatsDocument, options);
      }
export function useGetInfoPortalAggregateUsageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>(GetInfoPortalAggregateUsageStatsDocument, options);
        }
// @ts-ignore
export function useGetInfoPortalAggregateUsageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>;
export function useGetInfoPortalAggregateUsageStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInfoPortalAggregateUsageStatsQuery | undefined, GetInfoPortalAggregateUsageStatsQueryVariables>;
export function useGetInfoPortalAggregateUsageStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>(GetInfoPortalAggregateUsageStatsDocument, options);
        }
export type GetInfoPortalAggregateUsageStatsQueryHookResult = ReturnType<typeof useGetInfoPortalAggregateUsageStatsQuery>;
export type GetInfoPortalAggregateUsageStatsLazyQueryHookResult = ReturnType<typeof useGetInfoPortalAggregateUsageStatsLazyQuery>;
export type GetInfoPortalAggregateUsageStatsSuspenseQueryHookResult = ReturnType<typeof useGetInfoPortalAggregateUsageStatsSuspenseQuery>;
export type GetInfoPortalAggregateUsageStatsQueryResult = Apollo.QueryResult<GetInfoPortalAggregateUsageStatsQuery, GetInfoPortalAggregateUsageStatsQueryVariables>;
export const InfoPortalFreightReportDocument = gql`
    query InfoPortalFreightReport($freightRequest: LY7Request!) {
  findLY7Report(ly7Request: $freightRequest) {
    compcode
    logsys
    partnerno
    ponumber
    itemstatus
    fsdnumber
    grnumber
    deliverypostdate
    netamount
    currency
    extinvoice
    bmwdocno
    maxrows
    documentdate
  }
}
    `;

/**
 * __useInfoPortalFreightReportQuery__
 *
 * To run a query within a React component, call `useInfoPortalFreightReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalFreightReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalFreightReportQuery({
 *   variables: {
 *      freightRequest: // value for 'freightRequest'
 *   },
 * });
 */
export function useInfoPortalFreightReportQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables> & ({ variables: InfoPortalFreightReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>(InfoPortalFreightReportDocument, options);
      }
export function useInfoPortalFreightReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>(InfoPortalFreightReportDocument, options);
        }
// @ts-ignore
export function useInfoPortalFreightReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>;
export function useInfoPortalFreightReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalFreightReportQuery | undefined, InfoPortalFreightReportQueryVariables>;
export function useInfoPortalFreightReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>(InfoPortalFreightReportDocument, options);
        }
export type InfoPortalFreightReportQueryHookResult = ReturnType<typeof useInfoPortalFreightReportQuery>;
export type InfoPortalFreightReportLazyQueryHookResult = ReturnType<typeof useInfoPortalFreightReportLazyQuery>;
export type InfoPortalFreightReportSuspenseQueryHookResult = ReturnType<typeof useInfoPortalFreightReportSuspenseQuery>;
export type InfoPortalFreightReportQueryResult = Apollo.QueryResult<InfoPortalFreightReportQuery, InfoPortalFreightReportQueryVariables>;
export const InfoPortalFixedCostReportDocument = gql`
    query InfoPortalFixedCostReport($fixedCost: LY6Request!) {
  findLY6Report(ly6Request: $fixedCost) {
    compcode
    logsys
    partnerno
    ponumber
    fixedcostno
    invbaselinedate
    currency
    itemstatus
    extinvoice
    bmwdocno
    invpostdate
    overduestatus
    netamount
    maxrows
  }
}
    `;

/**
 * __useInfoPortalFixedCostReportQuery__
 *
 * To run a query within a React component, call `useInfoPortalFixedCostReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalFixedCostReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalFixedCostReportQuery({
 *   variables: {
 *      fixedCost: // value for 'fixedCost'
 *   },
 * });
 */
export function useInfoPortalFixedCostReportQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables> & ({ variables: InfoPortalFixedCostReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>(InfoPortalFixedCostReportDocument, options);
      }
export function useInfoPortalFixedCostReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>(InfoPortalFixedCostReportDocument, options);
        }
// @ts-ignore
export function useInfoPortalFixedCostReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>;
export function useInfoPortalFixedCostReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalFixedCostReportQuery | undefined, InfoPortalFixedCostReportQueryVariables>;
export function useInfoPortalFixedCostReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>(InfoPortalFixedCostReportDocument, options);
        }
export type InfoPortalFixedCostReportQueryHookResult = ReturnType<typeof useInfoPortalFixedCostReportQuery>;
export type InfoPortalFixedCostReportLazyQueryHookResult = ReturnType<typeof useInfoPortalFixedCostReportLazyQuery>;
export type InfoPortalFixedCostReportSuspenseQueryHookResult = ReturnType<typeof useInfoPortalFixedCostReportSuspenseQuery>;
export type InfoPortalFixedCostReportQueryResult = Apollo.QueryResult<InfoPortalFixedCostReportQuery, InfoPortalFixedCostReportQueryVariables>;
export const InfoPortalSupplierClaimsReportDocument = gql`
    query InfoPortalSupplierClaimsReport($supplierClaims: LY6Request!) {
  findLY5Report(ly5Request: $supplierClaims) {
    compcode
    logsys
    partnerno
    ponumber
    claimstatus
    poposition
    materialno
    description
    supplclaimno
    givolume
    matshareamnt
    handsurchamnt
    totalamnt
    currency
    extinvoice
    bmwdocno
    invpostdate
    invReference
    invbaselinedate
    overduestatus
    maxrows
  }
}
    `;

/**
 * __useInfoPortalSupplierClaimsReportQuery__
 *
 * To run a query within a React component, call `useInfoPortalSupplierClaimsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalSupplierClaimsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalSupplierClaimsReportQuery({
 *   variables: {
 *      supplierClaims: // value for 'supplierClaims'
 *   },
 * });
 */
export function useInfoPortalSupplierClaimsReportQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables> & ({ variables: InfoPortalSupplierClaimsReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>(InfoPortalSupplierClaimsReportDocument, options);
      }
export function useInfoPortalSupplierClaimsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>(InfoPortalSupplierClaimsReportDocument, options);
        }
// @ts-ignore
export function useInfoPortalSupplierClaimsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>;
export function useInfoPortalSupplierClaimsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalSupplierClaimsReportQuery | undefined, InfoPortalSupplierClaimsReportQueryVariables>;
export function useInfoPortalSupplierClaimsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>(InfoPortalSupplierClaimsReportDocument, options);
        }
export type InfoPortalSupplierClaimsReportQueryHookResult = ReturnType<typeof useInfoPortalSupplierClaimsReportQuery>;
export type InfoPortalSupplierClaimsReportLazyQueryHookResult = ReturnType<typeof useInfoPortalSupplierClaimsReportLazyQuery>;
export type InfoPortalSupplierClaimsReportSuspenseQueryHookResult = ReturnType<typeof useInfoPortalSupplierClaimsReportSuspenseQuery>;
export type InfoPortalSupplierClaimsReportQueryResult = Apollo.QueryResult<InfoPortalSupplierClaimsReportQuery, InfoPortalSupplierClaimsReportQueryVariables>;
export const RetrieveRevaluationReportDocument = gql`
    query RetrieveRevaluationReport($revaluationFilter: RevaluationFilter!) {
  findLY4Report(revaluationFilter: $revaluationFilter) {
    compcode
    logsys
    partnerno
    status
    purchaseordernumber
    poposition
    materialnumber
    description
    revalnumber
    revaltype
    oldnetamount
    newnetamount
    difference
    total
    currency
    documentdate
    bmwdocnumber
    grnumber
    overduestatus
    changedon
    maxrows
    extinvoice
    positions {
      revalnumber
      deliverynote
      grnumber
      material
      materialtext
      oldnet
      newnet
      diffnet
      currency
    }
  }
}
    `;

/**
 * __useRetrieveRevaluationReportQuery__
 *
 * To run a query within a React component, call `useRetrieveRevaluationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveRevaluationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveRevaluationReportQuery({
 *   variables: {
 *      revaluationFilter: // value for 'revaluationFilter'
 *   },
 * });
 */
export function useRetrieveRevaluationReportQuery(baseOptions: Apollo.QueryHookOptions<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables> & ({ variables: RetrieveRevaluationReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>(RetrieveRevaluationReportDocument, options);
      }
export function useRetrieveRevaluationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>(RetrieveRevaluationReportDocument, options);
        }
// @ts-ignore
export function useRetrieveRevaluationReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>): Apollo.UseSuspenseQueryResult<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>;
export function useRetrieveRevaluationReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>): Apollo.UseSuspenseQueryResult<RetrieveRevaluationReportQuery | undefined, RetrieveRevaluationReportQueryVariables>;
export function useRetrieveRevaluationReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>(RetrieveRevaluationReportDocument, options);
        }
export type RetrieveRevaluationReportQueryHookResult = ReturnType<typeof useRetrieveRevaluationReportQuery>;
export type RetrieveRevaluationReportLazyQueryHookResult = ReturnType<typeof useRetrieveRevaluationReportLazyQuery>;
export type RetrieveRevaluationReportSuspenseQueryHookResult = ReturnType<typeof useRetrieveRevaluationReportSuspenseQuery>;
export type RetrieveRevaluationReportQueryResult = Apollo.QueryResult<RetrieveRevaluationReportQuery, RetrieveRevaluationReportQueryVariables>;
export const XSuiteDownloadDocument = gql`
    query XSuiteDownload($fetchBlobRequest: FetchBlobRequest!) {
  retrieveRejectionLetterByURL(fetchBlobRequest: $fetchBlobRequest) {
    encodedFileData
    fileName
    mimeType
  }
}
    `;

/**
 * __useXSuiteDownloadQuery__
 *
 * To run a query within a React component, call `useXSuiteDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useXSuiteDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXSuiteDownloadQuery({
 *   variables: {
 *      fetchBlobRequest: // value for 'fetchBlobRequest'
 *   },
 * });
 */
export function useXSuiteDownloadQuery(baseOptions: Apollo.QueryHookOptions<XSuiteDownloadQuery, XSuiteDownloadQueryVariables> & ({ variables: XSuiteDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>(XSuiteDownloadDocument, options);
      }
export function useXSuiteDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>(XSuiteDownloadDocument, options);
        }
// @ts-ignore
export function useXSuiteDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>;
export function useXSuiteDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<XSuiteDownloadQuery | undefined, XSuiteDownloadQueryVariables>;
export function useXSuiteDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>(XSuiteDownloadDocument, options);
        }
export type XSuiteDownloadQueryHookResult = ReturnType<typeof useXSuiteDownloadQuery>;
export type XSuiteDownloadLazyQueryHookResult = ReturnType<typeof useXSuiteDownloadLazyQuery>;
export type XSuiteDownloadSuspenseQueryHookResult = ReturnType<typeof useXSuiteDownloadSuspenseQuery>;
export type XSuiteDownloadQueryResult = Apollo.QueryResult<XSuiteDownloadQuery, XSuiteDownloadQueryVariables>;
export const CorapiDocument = gql`
    query CORAPI($cr1Query: CR1Filter!) {
  findCR1ReportResults(cr1Query: $cr1Query) {
    id
    logsys
    companyCode
    companyName
    partnerNumber
    partnerName
    lfStreet
    lfCountry
    lfPostalCode
    lfCity
    vatNr
    poNumber
    materialNumber
    materialDescription
    deliveryNoteNumber
    deliveryNoteDate
    materialDocNumber
    gjahr
    grScItem
    grScDate
    grQuantity
    grUnit
    partnerLl
    partnerLlName
    llStreet
    llCountry
    llPostalCode
    llCity
    plantCode
    plantName
    plantAddress
    boardMemberName
    maxrows
    blobId
    documentCreated
    documentCreationDate
    yearMonth
    positions {
      logsys
      pos
      poNumber
      material
      materialText
      deliveryNote
      deliveryNoteDate
      materialDoc
      gjahr
      grScItem
      grScDate
      grQty
      grUnit
      plant
      plantName
      plantAddress
      boardMemberName
      companyName
    }
  }
}
    `;

/**
 * __useCorapiQuery__
 *
 * To run a query within a React component, call `useCorapiQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorapiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorapiQuery({
 *   variables: {
 *      cr1Query: // value for 'cr1Query'
 *   },
 * });
 */
export function useCorapiQuery(baseOptions: Apollo.QueryHookOptions<CorapiQuery, CorapiQueryVariables> & ({ variables: CorapiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorapiQuery, CorapiQueryVariables>(CorapiDocument, options);
      }
export function useCorapiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorapiQuery, CorapiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorapiQuery, CorapiQueryVariables>(CorapiDocument, options);
        }
// @ts-ignore
export function useCorapiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CorapiQuery, CorapiQueryVariables>): Apollo.UseSuspenseQueryResult<CorapiQuery, CorapiQueryVariables>;
export function useCorapiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CorapiQuery, CorapiQueryVariables>): Apollo.UseSuspenseQueryResult<CorapiQuery | undefined, CorapiQueryVariables>;
export function useCorapiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CorapiQuery, CorapiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CorapiQuery, CorapiQueryVariables>(CorapiDocument, options);
        }
export type CorapiQueryHookResult = ReturnType<typeof useCorapiQuery>;
export type CorapiLazyQueryHookResult = ReturnType<typeof useCorapiLazyQuery>;
export type CorapiSuspenseQueryHookResult = ReturnType<typeof useCorapiSuspenseQuery>;
export type CorapiQueryResult = Apollo.QueryResult<CorapiQuery, CorapiQueryVariables>;
export const FetchSapConfigurationDocument = gql`
    query FetchSapConfiguration {
  getSapSystemConfig {
    reportName
    description
    systemStatusList {
      id
      userName
      secretPlaceholder
      vaultProperty
      secret
      url
      path
      systemName
      systemNameFreeText
      filerResultsRule
      description
      active
      reachable
      placeHolderConfigured
      vaultPropertyFound
    }
  }
}
    `;

/**
 * __useFetchSapConfigurationQuery__
 *
 * To run a query within a React component, call `useFetchSapConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSapConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSapConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchSapConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>(FetchSapConfigurationDocument, options);
      }
export function useFetchSapConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>(FetchSapConfigurationDocument, options);
        }
// @ts-ignore
export function useFetchSapConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>;
export function useFetchSapConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<FetchSapConfigurationQuery | undefined, FetchSapConfigurationQueryVariables>;
export function useFetchSapConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>(FetchSapConfigurationDocument, options);
        }
export type FetchSapConfigurationQueryHookResult = ReturnType<typeof useFetchSapConfigurationQuery>;
export type FetchSapConfigurationLazyQueryHookResult = ReturnType<typeof useFetchSapConfigurationLazyQuery>;
export type FetchSapConfigurationSuspenseQueryHookResult = ReturnType<typeof useFetchSapConfigurationSuspenseQuery>;
export type FetchSapConfigurationQueryResult = Apollo.QueryResult<FetchSapConfigurationQuery, FetchSapConfigurationQueryVariables>;
export const FetchAppVariablesDocument = gql`
    query FetchAppVariables {
  getAllAppVariables {
    key
    value
  }
}
    `;

/**
 * __useFetchAppVariablesQuery__
 *
 * To run a query within a React component, call `useFetchAppVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAppVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAppVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAppVariablesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>(FetchAppVariablesDocument, options);
      }
export function useFetchAppVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>(FetchAppVariablesDocument, options);
        }
// @ts-ignore
export function useFetchAppVariablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>): Apollo.UseSuspenseQueryResult<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>;
export function useFetchAppVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>): Apollo.UseSuspenseQueryResult<FetchAppVariablesQuery | undefined, FetchAppVariablesQueryVariables>;
export function useFetchAppVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>(FetchAppVariablesDocument, options);
        }
export type FetchAppVariablesQueryHookResult = ReturnType<typeof useFetchAppVariablesQuery>;
export type FetchAppVariablesLazyQueryHookResult = ReturnType<typeof useFetchAppVariablesLazyQuery>;
export type FetchAppVariablesSuspenseQueryHookResult = ReturnType<typeof useFetchAppVariablesSuspenseQuery>;
export type FetchAppVariablesQueryResult = Apollo.QueryResult<FetchAppVariablesQuery, FetchAppVariablesQueryVariables>;
export const UpsertAppVariableDocument = gql`
    mutation UpsertAppVariable($input: AppVariableInput!) {
  addAppVariable(input: $input)
}
    `;
export type UpsertAppVariableMutationFn = Apollo.MutationFunction<UpsertAppVariableMutation, UpsertAppVariableMutationVariables>;

/**
 * __useUpsertAppVariableMutation__
 *
 * To run a mutation, you first call `useUpsertAppVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAppVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAppVariableMutation, { data, loading, error }] = useUpsertAppVariableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAppVariableMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAppVariableMutation, UpsertAppVariableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAppVariableMutation, UpsertAppVariableMutationVariables>(UpsertAppVariableDocument, options);
      }
export type UpsertAppVariableMutationHookResult = ReturnType<typeof useUpsertAppVariableMutation>;
export type UpsertAppVariableMutationResult = Apollo.MutationResult<UpsertAppVariableMutation>;
export type UpsertAppVariableMutationOptions = Apollo.BaseMutationOptions<UpsertAppVariableMutation, UpsertAppVariableMutationVariables>;
export const UpdateSapConfigurationDocument = gql`
    query UpdateSapConfiguration($sapConfig: SapSystemUpdateInput!) {
  updateSapSystemConfig(input: $sapConfig) {
    reportName
    description
    systemStatusList {
      url
      path
      active
      filerResultsRule
    }
  }
}
    `;

/**
 * __useUpdateSapConfigurationQuery__
 *
 * To run a query within a React component, call `useUpdateSapConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateSapConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateSapConfigurationQuery({
 *   variables: {
 *      sapConfig: // value for 'sapConfig'
 *   },
 * });
 */
export function useUpdateSapConfigurationQuery(baseOptions: Apollo.QueryHookOptions<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables> & ({ variables: UpdateSapConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>(UpdateSapConfigurationDocument, options);
      }
export function useUpdateSapConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>(UpdateSapConfigurationDocument, options);
        }
// @ts-ignore
export function useUpdateSapConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>;
export function useUpdateSapConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateSapConfigurationQuery | undefined, UpdateSapConfigurationQueryVariables>;
export function useUpdateSapConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>(UpdateSapConfigurationDocument, options);
        }
export type UpdateSapConfigurationQueryHookResult = ReturnType<typeof useUpdateSapConfigurationQuery>;
export type UpdateSapConfigurationLazyQueryHookResult = ReturnType<typeof useUpdateSapConfigurationLazyQuery>;
export type UpdateSapConfigurationSuspenseQueryHookResult = ReturnType<typeof useUpdateSapConfigurationSuspenseQuery>;
export type UpdateSapConfigurationQueryResult = Apollo.QueryResult<UpdateSapConfigurationQuery, UpdateSapConfigurationQueryVariables>;
export const DeleteSapSystemConfigDocument = gql`
    query DeleteSapSystemConfig($id: Float!) {
  deleteSapSystemConfig(id: $id) {
    reportName
    description
    systemStatusList {
      id
      url
      path
      active
      filerResultsRule
    }
  }
}
    `;

/**
 * __useDeleteSapSystemConfigQuery__
 *
 * To run a query within a React component, call `useDeleteSapSystemConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteSapSystemConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteSapSystemConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSapSystemConfigQuery(baseOptions: Apollo.QueryHookOptions<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables> & ({ variables: DeleteSapSystemConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>(DeleteSapSystemConfigDocument, options);
      }
export function useDeleteSapSystemConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>(DeleteSapSystemConfigDocument, options);
        }
// @ts-ignore
export function useDeleteSapSystemConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>): Apollo.UseSuspenseQueryResult<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>;
export function useDeleteSapSystemConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>): Apollo.UseSuspenseQueryResult<DeleteSapSystemConfigQuery | undefined, DeleteSapSystemConfigQueryVariables>;
export function useDeleteSapSystemConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>(DeleteSapSystemConfigDocument, options);
        }
export type DeleteSapSystemConfigQueryHookResult = ReturnType<typeof useDeleteSapSystemConfigQuery>;
export type DeleteSapSystemConfigLazyQueryHookResult = ReturnType<typeof useDeleteSapSystemConfigLazyQuery>;
export type DeleteSapSystemConfigSuspenseQueryHookResult = ReturnType<typeof useDeleteSapSystemConfigSuspenseQuery>;
export type DeleteSapSystemConfigQueryResult = Apollo.QueryResult<DeleteSapSystemConfigQuery, DeleteSapSystemConfigQueryVariables>;
export const CreateConfirmationOfArrivalPdfDocument = gql`
    query CreateConfirmationOfArrivalPDF($input: CR1PDFRequest!, $language: String!) {
  createConfirmationOfArrivalPDF(input: $input, language: $language) {
    blobId
    creationTime
  }
}
    `;

/**
 * __useCreateConfirmationOfArrivalPdfQuery__
 *
 * To run a query within a React component, call `useCreateConfirmationOfArrivalPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateConfirmationOfArrivalPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateConfirmationOfArrivalPdfQuery({
 *   variables: {
 *      input: // value for 'input'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateConfirmationOfArrivalPdfQuery(baseOptions: Apollo.QueryHookOptions<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables> & ({ variables: CreateConfirmationOfArrivalPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>(CreateConfirmationOfArrivalPdfDocument, options);
      }
export function useCreateConfirmationOfArrivalPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>(CreateConfirmationOfArrivalPdfDocument, options);
        }
// @ts-ignore
export function useCreateConfirmationOfArrivalPdfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>): Apollo.UseSuspenseQueryResult<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>;
export function useCreateConfirmationOfArrivalPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>): Apollo.UseSuspenseQueryResult<CreateConfirmationOfArrivalPdfQuery | undefined, CreateConfirmationOfArrivalPdfQueryVariables>;
export function useCreateConfirmationOfArrivalPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>(CreateConfirmationOfArrivalPdfDocument, options);
        }
export type CreateConfirmationOfArrivalPdfQueryHookResult = ReturnType<typeof useCreateConfirmationOfArrivalPdfQuery>;
export type CreateConfirmationOfArrivalPdfLazyQueryHookResult = ReturnType<typeof useCreateConfirmationOfArrivalPdfLazyQuery>;
export type CreateConfirmationOfArrivalPdfSuspenseQueryHookResult = ReturnType<typeof useCreateConfirmationOfArrivalPdfSuspenseQuery>;
export type CreateConfirmationOfArrivalPdfQueryResult = Apollo.QueryResult<CreateConfirmationOfArrivalPdfQuery, CreateConfirmationOfArrivalPdfQueryVariables>;
export const InfoPortalTnr1QueryApiDocument = gql`
    query InfoPortalTNR1QueryApi($tnr1Request: CommissionFilterInput!) {
  findTNR1ReportResults(tnr1Query: $tnr1Request) {
    logsys
    compCode
    compName
    documentNR
    documentDate
    dealerNR
    dealerName
    salesPartner
    vinNumber
    handOverDate
    brand
    modelCode
    commissionType
    recipient
    salesCategory
    valueType
    currency
    paymentType
    baseValue
    percentage
    netValuePaid
    grossValuePaid
    itemNr
    alphabet
  }
}
    `;

/**
 * __useInfoPortalTnr1QueryApiQuery__
 *
 * To run a query within a React component, call `useInfoPortalTnr1QueryApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPortalTnr1QueryApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPortalTnr1QueryApiQuery({
 *   variables: {
 *      tnr1Request: // value for 'tnr1Request'
 *   },
 * });
 */
export function useInfoPortalTnr1QueryApiQuery(baseOptions: Apollo.QueryHookOptions<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables> & ({ variables: InfoPortalTnr1QueryApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>(InfoPortalTnr1QueryApiDocument, options);
      }
export function useInfoPortalTnr1QueryApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>(InfoPortalTnr1QueryApiDocument, options);
        }
// @ts-ignore
export function useInfoPortalTnr1QueryApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>;
export function useInfoPortalTnr1QueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>): Apollo.UseSuspenseQueryResult<InfoPortalTnr1QueryApiQuery | undefined, InfoPortalTnr1QueryApiQueryVariables>;
export function useInfoPortalTnr1QueryApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>(InfoPortalTnr1QueryApiDocument, options);
        }
export type InfoPortalTnr1QueryApiQueryHookResult = ReturnType<typeof useInfoPortalTnr1QueryApiQuery>;
export type InfoPortalTnr1QueryApiLazyQueryHookResult = ReturnType<typeof useInfoPortalTnr1QueryApiLazyQuery>;
export type InfoPortalTnr1QueryApiSuspenseQueryHookResult = ReturnType<typeof useInfoPortalTnr1QueryApiSuspenseQuery>;
export type InfoPortalTnr1QueryApiQueryResult = Apollo.QueryResult<InfoPortalTnr1QueryApiQuery, InfoPortalTnr1QueryApiQueryVariables>;